import { Component, Input } from '@angular/core';

import { SmartModalService } from '../../../../../core/services/smart-modal.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'itpx-approve-consumption-request-modal',
    templateUrl: './approve-consumption-request-modal.component.html',
    styleUrls: ['./approve-consumption-request-modal.component.css']
})
export class ApproveConsumptionRequestModalComponent {

    @Input() data: {
        requestedBy: {
            userId: string;
            userFirstName: string;
            userLastName: string;
        };
    };

    form: FormGroup = new FormGroup({
        externalReference: new FormControl(),
    });

    constructor(
        private smartModalService: SmartModalService
    ) { }

    submit() {
        const externalReference: string = this.form.get('externalReference').value;
        this.smartModalService.sendResult({ externalReference });
    }

    cancel() {
        this.smartModalService.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/consumption-requests-approvals/approve-consumption-request-modal/approve-consumption-request-modal.component.ts